import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import { Header } from "components/atoms/header/index";
import NotificationPage from "components/molecules/notification-page";

import { UserService } from "core/service/user.service";
import { Loader } from "components/atoms/loader";
import { BUTTON_PROPS } from "./constants";
import * as S from "./activation-page.styles";

import SuccessTick from "assets/images/success-tick.png";

const ActivationPage = () => {
  const { activationCode } = useParams();
  const [activationDone, setActivationDone] = useState(false);
  useEffect(() => {
    UserService.activateAccount(activationCode).then((res) => {
      if (res) {
        setActivationDone(true);
        setTimeout(() => (window.location.href = BUTTON_PROPS.href), 5000);
      }
    });
  }, [activationCode]);

  return (
    <>
      <Header company={"simpletax"} />
      {activationDone ? (
        <S.StyledCard>
          <NotificationPage
            header={"activationCode.activationHeader"}
            body={"activationCode.activatedText"}
            image={SuccessTick}
            buttonProps={BUTTON_PROPS}
          />
        </S.StyledCard>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default ActivationPage;
